import { render } from "./CompanySettings.vue?vue&type=template&id=3da1580a&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"

import "./CompanySettings.vue?vue&type=style&index=0&id=3da1580a&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da1580a"]])

export default __exports__